/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "Constants";

const normalizeText = (value) => (value ?? "").toString().trim();

const normalizeUserType = (value) => {
  const normalized = normalizeText(value).toUpperCase();
  return normalized === "DRIVER" ? "DRIVER" : "USER";
};

const hasAccountFields = (candidate) =>
  Boolean(
    candidate &&
      typeof candidate === "object" &&
      [
        candidate.email,
        candidate.userEmail,
        candidate.contactEmail,
        candidate.firstName,
        candidate.first_name,
        candidate.givenName,
        candidate.lastName,
        candidate.last_name,
        candidate.surname,
        candidate.phone,
        candidate.phoneNumber,
        candidate.mobileNumber,
        candidate.mobile,
        candidate.contactPhone,
      ].some((value) => Boolean(normalizeText(value)))
  );

const getAccountSource = (details = {}) => {
  const candidates = [
    details?.driverInfoDetails,
    details?.passengerInfoDetails,
    details?.userInfoDetails,
    details?.customerInfoDetails,
    details?.customerDetails,
    details?.userDetails,
    details?.profile,
    details?.accountDetails,
    details,
  ];

  return candidates.find(hasAccountFields) || details || {};
};

const getPhoneDigits = (details = {}) => {
  const source = getAccountSource(details);
  const rawPhone =
    source?.phone ||
    source?.phoneNumber ||
    source?.mobileNumber ||
    source?.mobile ||
    source?.contactPhone ||
    source?.email ||
    "";

  return normalizeText(rawPhone).replace(/\D/g, "");
};

const buildTemporaryPassword = (details = {}, userType = "USER") => {
  const digits = getPhoneDigits(details).slice(-6).padStart(6, "0");
  const prefix = normalizeUserType(userType) === "DRIVER" ? "Driver" : "User";
  return `${prefix}@${digits || "123456"}`;
};

const buildAccountPayload = (details = {}, userType = "USER") => {
  const normalizedUserType = normalizeUserType(userType);
  const source = getAccountSource(details);
  const email = normalizeText(source?.email || source?.userEmail || source?.contactEmail);
  const firstName = normalizeText(
    source?.firstName || source?.first_name || source?.givenName
  );
  const lastName = normalizeText(source?.lastName || source?.last_name || source?.surname);
  const phone = normalizeText(
    source?.phone ||
      source?.phoneNumber ||
      source?.mobileNumber ||
      source?.mobile ||
      source?.contactPhone
  );
  const country = normalizeText(source?.country || source?.countryCode || "CM").substring(0, 2).toUpperCase();;
  const currency = normalizeText(source?.currency || "XAF") || "XAF";

  return {
    email,
    password: buildTemporaryPassword(details, normalizedUserType),
    firstName,
    lastName,
    phone,
    currency,
    country,
    role: normalizedUserType === "DRIVER" ? "driver" : "consumer",
    userType: normalizedUserType,
  };
};

const createAccount = (details = {}, userType = "USER") => {
  const payload = buildAccountPayload(details, userType);

  return axios.post(API_ENDPOINTS.LEWOO_PAY_REGISTER, payload, {
    headers: {
      isAuthRequired: false,
      "Content-Type": "application/json",
      "x-tenant-slug": "default",
    },
  });
};

export default {
  buildAccountPayload,
  createAccount,
};
